export default "__VITE_ASSET__DjgZN5T___"